const ShapeType = {
	POLYGON: "Polygon",
	LINE: "Line",
	POINTS: "Points"
};
export default ShapeType;
